import { PageRoutes } from '../../../conf/Global';

export const breadcrumbConstantService = () => {
    const routeStructure = {
        'Enterprise Data Catalog': {
            route: '/',
            Browse: {
                // route: routeUtilService.routes.aiAgents.path,
                Dataset: {
                    route: PageRoutes.BROWSE_DATASET,
                    'Dataset Details': {
                        route: PageRoutes.DATASET_DETAILS,
                    },
                },
                'Data Products': {
                    route: PageRoutes.BROWSE_DATAPRODUCT,
                    'Data Product Details': {
                        route: PageRoutes.DATA_PRODUCT_DETAILS,
                    },
                },
                'Data Products ': {
                    route: PageRoutes.BROWSE_DATA_PRODUCT,
                },
                Chart: {
                    route: PageRoutes.BROWSE_CHART,
                    'Chart Details': {
                        route: PageRoutes.CHART_DETAILS,
                    },
                },
                Dashboard: {
                    route: PageRoutes.BROWSE_DASHBOARD,
                    'Dashboard Details': {
                        route: PageRoutes.DASHBOARD_DETAILS,
                    },
                },
                Pipelines: {
                    route: PageRoutes.BROWSE_PIPELINES,
                    'Pipeline Details': {
                        route: PageRoutes.PIPELINE_DETAILS,
                    },
                },
                'Feature Tables': {
                    route: PageRoutes.BROWSE_FEATURE_TABLES,
                    'Feature Table Details': {
                        route: PageRoutes.FEATURE_TABLE_DETAILS,
                    },
                },
                'ML Models': {
                    route: PageRoutes.BROWSE_ML_MODELS,
                    'ML Model Details': {
                        route: PageRoutes.ML_MODEL_DETAILS,
                    },
                },
                'ML Model Groups': {
                    route: PageRoutes.BROWSE_ML_MODEL_GROUP,
                    'ML Model Group Details': {
                        route: PageRoutes.ML_MODEL_GROUP_DETAILS,
                    },
                },
            },
            Search: {
                route: PageRoutes.SEARCH,
            },
            Settings: {
                route: PageRoutes.SETTINGS,
                Permissions: {
                    route: `${PageRoutes.SETTINGS}${PageRoutes.PERMISSIONS}`,
                    Policies: {
                        route: `${PageRoutes.SETTINGS}${PageRoutes.PERMISSIONS}${PageRoutes.POLICIES}`,
                    },
                },
                Identities: { route: `${PageRoutes.SETTINGS}${PageRoutes.IDENTITIES}/users` },
                Ownership: { route: `${PageRoutes.SETTINGS}${PageRoutes.OWNERSHIP}` },
                Tokens: { route: `${PageRoutes.SETTINGS}${PageRoutes.TOKENS}` },
                Posts: { route: PageRoutes.SETTINGS_POSTS },
                Views: { route: PageRoutes.SETTINGS_VIEWS },
            },
            Glossary: {
                route: PageRoutes.GLOSSARY,
                'Glossary Node Details': {
                    route: PageRoutes.GLOSSARY_NODE,
                },
                'Glossary Term Details': {
                    route: PageRoutes.GLOSSARY_TERM_DETAILS,
                },
            },
            Domains: {
                route: PageRoutes.DOMAINS,
                Domain: {
                    route: PageRoutes.DOMAIN,
                },
            },
            Analytics: {
                route: PageRoutes.ANALYTICS,
            },
            'Manage Ingestion': {
                route: PageRoutes.INGESTION,
            },
            Embed: {
                route: PageRoutes.EMBED,
            },
            Group: {
                route: PageRoutes.GROUP,
            },
            User: {
                route: PageRoutes.USER,
            },
            Container: {
                route: PageRoutes.CONTAINER,
            },
            Tags: {
                route: PageRoutes.TAG,
            },
        },
    };
    return {
        routeStructure,
    };
};
